import styled from 'styled-components';
import { TITLE_SIZE_4, TITLE_SIZE_5 } from '../../const/text';
import { SECONDARY_COLOR, SECONDARY_COLOR_3 } from '../../const/color';
import { device } from '../../const/device';

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  height: 36px;
  align-items: center;
  margin-bottom: 10px;
  justify-content: space-between;
  
  @media (${device.mobileL}) {
    height: 24px;
  }
`;

export const IconContainer = styled.div`
    top: 0px;
    right: 0;
    display:flex;
  > button {
    margin-left: 16px;
  }
`;
export const TitleContainer = styled.div<{ themeColor : string}>`
  font-size: ${TITLE_SIZE_4}px;
  line-height: 130%;
  color: ${props => props.themeColor == "black"?'#ffffff':SECONDARY_COLOR};
  letter-spacing: 0.005em;
  text-transform: uppercase;
  @media (${device.mobileL}) {
    font-size: ${TITLE_SIZE_5}px;
  }
`;


export const List = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-gap: 22px 10px;
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100vh - 215px);
  margin-top: 15px;
  align-content: start;

  @media (${device.tablet}) {
    grid-template-columns: repeat(10, 1fr);
    grid-gap: 22px 24px;
    height: calc(100vh - 230px);
  }

  @media (${device.tabletM}) {
    grid-template-columns: repeat(7, 1fr);
  }

  @media (${device.tabletS}) {
    grid-template-columns: repeat(5, 1fr);
    grid-gap: 22px 10px;
  }

  @media (${device.mobileM}) {
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 22px 24px;
  }
`;

export const Item = styled.div<{ flag: string, active: boolean }>`
  width: 50px;
  height: 32px;
  cursor: pointer;
  background: url("${props => props.flag}") center no-repeat;
  outline: ${props => props.active ? `solid ${SECONDARY_COLOR_3} 3px` : ''};
  background-size: cover;
  margin: auto;
  border: 1px solid #0000001f;
  
  &:hover {
    outline: 1px solid ${SECONDARY_COLOR_3};
  }
`;
